export const LOGIN_ADMIN_REQUEST = "LOGIN_ADMIN_REQUEST"
export const LOGIN_ADMIN_REQUEST_SUCCESS = "LOGIN_ADMIN_REQUEST_SUCCESS"
export const LOGIN_ERROR = "LOGIN_ERROR"

export const CHECK_ADMIN_REQUEST = "CHECK_ADMIN_REQUEST"
export const CHECK_ADMIN_REQUEST_SUCCESS = "CHECK_ADMIN_REQUEST_SUCCESS"
